import React, { useContext } from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import { CoreBadgeType } from '../../coreBadge/types';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import SophisticatedTooltipLink from '@wix/da-ds/pkg/tooltips/SophisticatedTooltipLink';
import { ThemeContext, ThemeOptions, } from '@wix/da-react-context/pkg/ThemeContext';
import { useCustomNotifications } from '../../Notifications/CustomNotificationContext';
import { NotificationType } from '../../Notifications';
import { badgeNotificationsFilter } from '../utils';
import SophisticatedTooltip from '@wix/da-ds/pkg/tooltips/dsPreset/SophisticatedTooltip';
import ConditionalWrapper from '../../ConditionalWrapper';
import s from './CoreBadgeButton.scss';
function getTooltipHeaderTranslation(type) {
    switch (type) {
        case CoreBadgeType.DIAMOND:
            return 'coreBadge.tooltip.diamond.header';
        case CoreBadgeType.EMERALD:
            return 'coreBadge.tooltip.emerald.header';
        case CoreBadgeType.GLASS:
            return 'coreBadge.tooltip.glass.header';
        default:
            return '';
    }
}
function getTooltipDescriptionTranslation(type) {
    switch (type) {
        case CoreBadgeType.DIAMOND:
            return 'coreBadge.tooltip.diamond.description';
        case CoreBadgeType.EMERALD:
            return 'coreBadge.tooltip.emerald.description';
        case CoreBadgeType.GLASS:
            return 'coreBadge.tooltip.glass.description';
        default:
            return '';
    }
}
function getTooltipIconUrl(type) {
    switch (type) {
        case CoreBadgeType.DIAMOND:
            return Url.staticCDNLink('eclipse/global/images/diamond-sm.png');
        case CoreBadgeType.EMERALD:
            return Url.staticCDNLink('eclipse/global/images/emerald-sm.png');
        case CoreBadgeType.GLASS:
            return Url.staticCDNLink('eclipse/global/images/quartz-sm.png');
        default:
            return '';
    }
}
var CoreBadgeButton = function (_a) {
    var type = _a.type, recipient = _a.recipient, badges = _a.badges, className = _a.className, children = _a.children, biData = _a.biData, hideTooltip = _a.hideTooltip, pushAwardsModal = _a.pushAwardsModal;
    var t = useTranslation().t;
    var notifications = useCustomNotifications([NotificationType.Badge]).notifications;
    var hasNotification = notifications.some(badgeNotificationsFilter(type));
    var reverseTheme = useContext(ThemeContext) === ThemeOptions.LIGHT
        ? ThemeOptions.DARK
        : ThemeOptions.LIGHT;
    return (React.createElement(ConditionalWrapper, { condition: !hideTooltip &&
            [
                CoreBadgeType.GLASS,
                CoreBadgeType.EMERALD,
                CoreBadgeType.DIAMOND,
            ].includes(type), wrap: function (child) { return (React.createElement(SophisticatedTooltip, { isVisible: hasNotification ? false : undefined, heading: t(getTooltipHeaderTranslation(type)), description: t(getTooltipDescriptionTranslation(type)), placement: 'top', forceTheme: reverseTheme, usePortal: true, prefix: React.createElement("img", { src: getTooltipIconUrl(type), className: s['badge-icon'], width: 56, height: 56, alt: type }), width: 345, postfix: React.createElement(SophisticatedTooltipLink, { href: "https://www.deviantartsupport.com/en/article/what-are-badges-and-fragments", target: "_blank", rel: "noreferrer" }, t('coreBadge.tooltip.learn')), size: 'medium' }, child)); } },
        React.createElement(PlainButtonOrLink, { className: c(s['toggle'], className), onClick: function () {
                return pushAwardsModal({
                    badges: badges,
                    recipient: recipient,
                    defaultActiveType: type,
                });
            }, biData: biData }, children)));
};
CoreBadgeButton.displayName = 'CoreBadgeButton';
export default CoreBadgeButton;
//# sourceMappingURL=CoreBadgeButton.js.map